import BaseType from "@/types/BaseType";

export default class CanvasCourseMapping extends BaseType {
  CanvasCourseId: number = 0;
  TrainingTypeId: string = "";
  TrainingDeliveredId: string | null = null;
  OtherTrainingName: string | null = null;
  // Stored on the backend as jsonb; serialize/deserialize via JSON.stringify in the form.
  SkillsEnumerationIdsJson: string = "[]";
  // jsonb array of "TrainingDeliveryFormats" enumeration ids (e.g. asynchronous/online).
  DeliveryFormatEnumerationIdsJson: string = "[]";
  Hours: number = 0;
  IsActive: boolean = true;
}
